import React from 'react';
import { CardContainer } from '../../shared/components/card';
import { Tabs } from '../../shared/components/tabs';

export class TabsDevelopmentPage extends React.Component {
  render(): JSX.Element {
    return (
      <div className='bg-gray-lightest w-full min-h-screen'>
        <div className='w-3/4 mx-auto py-20'>
          <h1>Tabs Development</h1>
          <CardContainer stripPadding={true}>
            {/* Start Tabs Development Here */}
            <Tabs initial='one'>
              <div className='flex flex-row items-center justify-between divide-x divide-gray-light border-t border-b border-gray-light'>
                <Tabs.Tab label='one'>1. Basic Info</Tabs.Tab>
                <Tabs.Tab label='two'>2. Add Form Section</Tabs.Tab>
              </div>

              <div>
                <Tabs.Panel label='one'>
                  <h2>Tab Panel One</h2>
                  <p className='text-red'>
                    Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                    Odit architecto nesciunt facilis libero incidunt earum,
                    adipisci doloribus ab magni distinctio, blanditiis
                    necessitatibus magnam nihil maiores placeat qui cupiditate?
                    Ullam, officia.
                  </p>
                </Tabs.Panel>
                <Tabs.Panel label='two'>
                  <h2>Tab Panel Two</h2>
                  <p className='text-blue'>
                    Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                    Odit architecto nesciunt facilis libero incidunt earum,
                    adipisci doloribus ab magni distinctio, blanditiis
                    necessitatibus magnam nihil maiores placeat qui cupiditate?
                    Ullam, officia.
                  </p>
                </Tabs.Panel>
              </div>
            </Tabs>
            {/* End Tabs Development Here */}
          </CardContainer>
        </div>
      </div>
    );
  }
}
